export class CampaignTask {
  id!: string;
  campaignId?: string;
  campaignName?: string;
  creatorName?: string;
  description!: string;
  dueDate!: string;
  paymentRelated!: boolean;
  dueDateString!: string;
  complete!: boolean;
  creatorFacing!: boolean;

  get pastDue(): boolean {
    const today = new Date().toISOString().split('T')[0];
    return !this.complete && this.dueDate < today;
  }

  get dueToday(): boolean {
    const today = new Date().toISOString().split('T')[0];
    return !this.complete && this.dueDate === today;
  }

  get color(): string {
    return this.complete ? '#c1cbb1' : '#f2b4a3';
  }

  constructor() {
    const futureDate = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];

    // "id": crypto.randomUUID(), "description": "New Task", complete: false, dueDate: futureDate, dueDateString: ''
    this.id = crypto.randomUUID();
    this.description = 'New Task';
    this.complete = false;
    this.dueDate = futureDate;
    this.dueDateString = '';
  }

}
